import React from 'react';
import { inject, observer } from 'mobx-react';
import { toJS } from 'mobx';
import { Row, Col, Button, Icon, Menu, Popover } from 'antd';
import AppDatasBody from '../../util/AppDatasBody';
import Navigation from '../../public/navigation';
import BasicInfo from './BasicInfo';
import Comment from './Comment';
import Log from './Log';
import Developer from './Developer';
import Solution from './Solution';
import ApplyApp from '../../util/appApply/index';
import DocConstant from '../../util/appApply/validate';
import util from '../../../util';
const { isWeaver, defaultCustomSearchValue } = util;
const isweaver = isWeaver();
const store = ['modeListStore', 'homeStore', 'appDetailStore', 'listStore'];
const {
  checkLicense,
} = DocConstant;
@inject(...store)
@observer
class App extends React.Component {
  static defaultProps = {
    prefixCls: 'app-detail',
  }
  constructor(props) {
    super(props);
    this.state = {
      selectedKeys: ['basicinfo'],
    }
  }
  componentDidMount() {
    const { location, modeListStore: { getAppDetail } } = this.props;
    const id = location.pathname.split('/').reverse()[0];
    getAppDetail({ id });
    window.scrollTo(0, 0);
  }
  onNavClick = (item) => {
    const { modeListStore: { routing }, homeStore: { type } } = this.props;
    if (item.key === '1') routing.push('/');
    else if (item.key === '2') {
      routing.push({
        pathname: item.path,
        query: {
          id: toJS(type).id,
        }
      })
    }
  }
  renderRight = () => {
    const { prefixCls } = this.props;
    const { selectedKeys } = this.state;
    if (selectedKeys[0] === 'comment') return (<Comment {...this.props} prefixCls={`${prefixCls}-comment`} />);
    else if (selectedKeys[0] === 'log') return (<Log {...this.props} prefixCls={`${prefixCls}-log`} />);
    else if (selectedKeys[0] === 'developer') return (<Developer {...this.props} prefixCls={`${prefixCls}-developer`} />);
    else if (selectedKeys[0] === 'solution') return (<Solution {...this.props} prefixCls={`${prefixCls}-solution`} />)
    return (<BasicInfo {...this.props} prefixCls={`${prefixCls}-basicinfo`} />);
  }
  onMenuSelect = (item) => {
    const { modeListStore: { appDetail }, appDetailStore: { getDeb } } = this.props;
    if (item.key === 'comment' && toJS(appDetail).app) getDeb({ sw_id: toJS(appDetail).app.sw_id, s_number: toJS(appDetail).app.s_number });
    this.setState({ selectedKeys: item.selectedKeys });
  }
  share = (e) => {
    console.log(e);
  }
  apply = () => {
    if (!isweaver) return;
    const { modeListStore: { appDetail, setMobxState, getAppDetail } } = this.props;
    getAppDetail({ id: toJS(appDetail).app.sw_id }).then(() => {
      setMobxState({ visibleOfApply: true });
    });
  }
  onFormChange = (values, allValues) => {
    const { modeListStore: { applyLicense, setMobxState, appDetail } } = this.props;
    const data = toJS(appDetail);
    setMobxState({ isApply: false });
    if (Object.keys(values).indexOf('license') >= 0) {
      checkLicense(values.license) && applyLicense({
        sw_id: data.sw_id,
        ec_id: allValues.c_id,
        c_id: allValues.c_id,
        ecname: allValues.c_name,
        license: values.license,
      });
    }
  }
  collect = () => {
    if (!isweaver) return;
    const { modeListStore: { getAppDetail, appDetail, callCollect } } = this.props;
    const data = toJS(appDetail).app || {};
    callCollect({ collect: data.tms_iscoll === '0' ? '1' : '0', s_ids: data.sw_id }).then(() => {
      getAppDetail({ id: data.sw_id });
    });
  }
  render() {
    const navs = [
      { key: '1', breadcrumbName: '云商店', path: '/' },
      { key: '2', breadcrumbName: '应用', path: '/app' },
      { key: '3', breadcrumbName: '详情', path: '/' },
    ];
    const { selectedKeys } = this.state;
    const { location, prefixCls } = this.props;
    const { modeListStore: { visibleOfApply, setMobxState } } = this.props;
    let { modeListStore: { appDetail } } = this.props;
    appDetail = toJS(appDetail);
    const { app = {} } = appDetail;
    const hasDocFile = app && app.docfile && app.docfile.length > 0;
		const url = "http://www.e-cology.com.cn/cloudstore/system/GoToCloudStore.jsp?ip=e-cloudstore.com&path=/app/" + app.sw_id + "/show";
    return (
      <div className={prefixCls}>
        <AppDatasBody location={location}>
          <Navigation datas={navs} onClick={this.onNavClick} />
          <Row className={`${prefixCls}-header`}>
            <Col span={5}><span className="app-detail-label">应用编码：</span><span>{app && app.s_number}</span></Col>
            <Col span={5}><span className="app-detail-label">应用名称：</span><span>{app && app.s_name}</span></Col>
            <Col span={5}><span className="app-detail-label">版本：</span><span>{app && app.s_version}</span></Col>
            <Col span={9} className={`${prefixCls}-header-btns`}>
              {
                isweaver && (
                  <Popover content={<div>
                    <p>请复制如下链接分享</p>
                    <p>
                      <a id="cs-app-header-share" target='_blank' href={url} ref="share">
                        {app.s_name}
                      </a>
                    </p>
                  </div>} trigger="click">
                    <Button disabled={!isweaver}><div onClick={this.share}>分享</div></Button>
                  </Popover>
                )
              }
              {
                isweaver && (
                  <div className={`${prefixCls}-header-btn`} onClick={this.collect}><Icon type="star" theme="filled" style={ app.tms_iscoll === '0' ? { color: '#ffa11b'} : {}}/><span>收藏</span></div>
                )
              }
              <Button type="ghost" onClick={()=>{window.open("http://e8pc.e-cology.com.cn/mobilemode/apps/online/index_cs.html?url=http://e8pc.e-cology.com.cn"+app.s_mobiurl)}}
								  disabled={!app.s_mobiurl || (app.s_mobiurl && app.s_mobiurl === "") || window.isIE8 || window.isIE9}>在线体验</Button>
              <Button type="primary" disabled={!isweaver} onClick={this.apply}>☑ 申请</Button>
            </Col>
          </Row>
          <div className={`${prefixCls}-body`}>
            <div className={`${prefixCls}-body-left`}>
              <Menu
                mode="inline"
                selectedKeys={selectedKeys}
                onSelect={this.onMenuSelect}
              >
                <Menu.Item key="basicinfo">
                  <Icon type="book" />基本信息
        	       </Menu.Item>
                <Menu.Item key="comment" disabled={!localStorage.me}>
                  <Icon type="message" />评论
                </Menu.Item>
                <Menu.Item key="log">
                  <Icon type="tag-o" />历史版本
                </Menu.Item>
                <Menu.Item key="developer">
                  <Icon type="user" />参与者
                </Menu.Item>
                {
                  hasDocFile && (
                    <Menu.Item key="solution">
                      <Icon type="book" />解决方案
                    </Menu.Item>
                  )
                }
              </Menu>
            </div>
            <div className={`${prefixCls}-body-right`}>
              {this.renderRight()}
            </div>
            <ApplyApp visible={visibleOfApply} onChange={(v) => setMobxState({ visibleOfApply: v })} data={appDetail} onFormChange={this.onFormChange} />
          </div>
        </AppDatasBody>
      </div>
    )
  }
}

export default App;


// WEBPACK FOOTER //
// ./src/components/mode/appDetail/index.js